import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import {
  layDanhSachPhuTro,
  layDanhSachQuocGia,
  tinhPhiVe,
} from "../services/flightService";
import { formatDate, isEmptyObject } from "../helpers/function_helper";
import LoadingPage from "../components/LoadingPage";
import CustomDateInput from "../components/CustomDateInput";
import SweetAlert from "react-bootstrap-sweetalert";
import "../assets/scss/style.scss";

export default function CustomerInfo() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const isOnResponsePage = localStorage.getItem("isOnResponsePage");
    if (isOnResponsePage === "true") {
      navigate("/");
    }
  }, []);

  const location = useLocation();
  const [isNext, setIsNext] = useState(false);
  const [dsDichVu, setDSDichVu] = useState({});
  const [sweetAlert, setSweetAlert] = useState({
    isShow: false,
    baseProps: {},
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // Get passenger counts from location.state (default to 1 adult if not provided)
  const adults = location.state.passengers?.adults != undefined ? location.state.passengers?.adults : location.state.passengers?.filter(val => val.type === "Adult").length;
  const children = location.state.passengers?.children != undefined ? location.state.passengers?.children : location.state.passengers?.filter(val => val.type === "Child").length;
  const infants = location.state.passengers?.infants != undefined ? location.state.passengers?.infants : location.state.passengers?.filter(val => val.type === "Infant").length;
  // Lấy danh sách các hãng bay từ location.state.flight
  const airlines = Array.isArray(location.state?.flight)
    ? Array.from(
        new Set(
          location.state.flight
            .map((item) => item?.hang_bay?.api)
            .filter(Boolean)
        )
      )
    : [];

  const onCancel = () => {
    setSweetAlert((preState) => ({
      ...preState,
      isShow: false,
    }));
  };

  const getNgaySinhDefault = (loaiHanhKhach) => {
    var currentDate = new Date();
    currentDate.setFullYear(
      currentDate.getFullYear() -
        (loaiHanhKhach == 1 ? 13 : loaiHanhKhach == 2 ? 3 : 1)
    );
    var day = currentDate.getDate().toString().padStart(2, "0");
    var month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    var year = currentDate.getFullYear();
    var formattedDate = day + "-" + month + "-" + year;
    return formattedDate;
  };

  useEffect(() => {
    if (location.state?.flight) {
      var airCheck = location.state.flight.filter(
        (item) => item?.hang_bay?.api === "uAPI" || item?.hang_bay?.api === "QH"
      );
      if (airCheck.length > 0) return;
    }

    var hanhKhach = [];
    var changBay = [];
    for (let i = 0; i < location.state.passengers["adults"]; i++) {
      hanhKhach.push({
        danh_xung: 1,
        ho: JSON.parse(process.env.REACT_APP_BOOKER_INFO).ho,
        ten: JSON.parse(process.env.REACT_APP_BOOKER_INFO).ten,
        ten_dem: JSON.parse(process.env.REACT_APP_BOOKER_INFO).ten,
        loai_hanh_khach: 1,
        hanh_khach_id: i + 1,
        ngay_sinh: getNgaySinhDefault(1),
        so_dien_thoai: JSON.parse(process.env.REACT_APP_BOOKER_INFO)
          .so_dien_thoai,
        email: JSON.parse(process.env.REACT_APP_BOOKER_INFO).email,
        cha_me_id: "",
        index: i + 1,
      });
    }

    for (let i = 0; i < location.state.passengers["children"]; i++) {
      hanhKhach.push({
        danh_xung: 4,
        ho: JSON.parse(process.env.REACT_APP_BOOKER_INFO).ho,
        ten: JSON.parse(process.env.REACT_APP_BOOKER_INFO).ten,
        ten_dem: JSON.parse(process.env.REACT_APP_BOOKER_INFO).ten,
        loai_hanh_khach: 2,
        hanh_khach_id: i + 1 + location.state.passengers["adults"],
        ngay_sinh: getNgaySinhDefault(2),
        so_dien_thoai: JSON.parse(process.env.REACT_APP_BOOKER_INFO)
          .so_dien_thoai,
        email: JSON.parse(process.env.REACT_APP_BOOKER_INFO).email,
        cha_me_id: "",
        index: i + 1 + location.state.passengers["adults"],
      });
    }

    for (let i = 0; i < location.state.passengers["infants"]; i++) {
      hanhKhach.push({
        danh_xung: 6,
        ho: JSON.parse(process.env.REACT_APP_BOOKER_INFO).ho,
        ten: JSON.parse(process.env.REACT_APP_BOOKER_INFO).ten,
        ten_dem: JSON.parse(process.env.REACT_APP_BOOKER_INFO).ten,
        loai_hanh_khach: 3,
        hanh_khach_id:
          i +
          1 +
          location.state.passengers["adults"] +
          location.state.passengers["children"],
        ngay_sinh: getNgaySinhDefault(3),
        so_dien_thoai: JSON.parse(process.env.REACT_APP_BOOKER_INFO)
          .so_dien_thoai,
        email: JSON.parse(process.env.REACT_APP_BOOKER_INFO).email,
        cha_me_id: i + 1,
        index:
          i +
          1 +
          location.state.passengers["adults"] +
          location.state.passengers["children"],
      });
    }

    location.state.flight.forEach((f, flightIdx) => {
      changBay.push({
        index: 1,
        uuid: f.uuid,
        index_hang_cho: f.tuy_chon_gia_ve_mac_dinh.index,
      });
    });

    var result = {
      chang_bay: changBay,
      hanh_khach: hanhKhach,
    };

    const fetchSupportServices = async () => {
      try {
        const data = await layDanhSachPhuTro(result);
        if (data.code === 200) {
          setDSDichVu(data.data);
        } else if (data) {
          setLoading(false);
          setSweetAlert((preState) => ({
            ...preState,
            isShow: true,
            baseProps: {
              title: "Thông báo",
              confirmBtnBsStyle: "success",
              cancelBtnBsStyle: "danger",
              showCloseButton: true,
              showConfirm: false,
              type: "warning",
              onCancel: onCancel,
              ContentRender: <p>{data.message}</p>,
            },
          }));
        }
      } catch (error) {}
    };

    fetchSupportServices();
  }, []);

  // Helper to create empty passenger info
  const createPassenger = (type = "Adult") => {
    let titleDefault = "1"; // Adult: "Ông"
    if (type === "Child") titleDefault = "4"; // Child: "Trẻ em trai"
    if (type === "Infant") titleDefault = "6"; // Infant: "Bé trai"
    return {
      name: "",
      title: titleDefault,
      passport: "",
      dob: "",
      accompanyingAdult: "", // Only used for infants
      the_thanh_vien_vn: "",
      the_thanh_vien_vj: "",
      the_thanh_vien_qh: "",
      quoc_tich: "VNM",
      ngay_het_han: "",
      quoc_gia_cap: "VNM",
    };
  };

  // Build passenger list
  const passengerList = [
    ...Array(adults).fill({ type: "Adult" }),
    ...Array(children).fill({ type: "Child" }),
    ...Array(infants).fill({ type: "Infant" }),
  ];

  const [passengers, setPassengers] = useState(
    passengerList.map((val) => ({
      ...createPassenger(val.type),
      type: val.type,
    }))
  );
  const [errors, setErrors] = useState(passengerList.map(() => ({})));

  // Thông tin liên hệ
  const [contact, setContact] = useState({ so_dien_thoai: "", email: "" });
  const [contactError, setContactError] = useState({
    so_dien_thoai: "",
    email: "",
  });

  // State cho options quốc tịch và quốc gia cấp
  const [countryOptions, setCountryOptions] = useState([]);

  // Khôi phục dữ liệu khi quay lại từ Service
  useEffect(() => {
    if (location.state?.passengers && location.state?.isReturn) {
      setPassengers(location.state.passengers);
      if (location.state?.contact) {
        setContact(location.state.contact);
      }
    }
  }, [location.state]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const dataRes = await layDanhSachQuocGia();
        const option = dataRes.data.map((element) => ({
          label: element.ten,
          value: element.ma,
        }));
        setCountryOptions(option);
      } catch (error) {
        setCountryOptions([]);
      }
    };

    fetchCountries();
  }, []);

  // Handle input change (add accompanyingAdult)
  const handleChange = (idx, field, value) => {
    const newPassengers = [...passengers];
    newPassengers[idx][field] = value;
    setPassengers(newPassengers);

    // Remove error if valid
    if (value !== null && value !== "" && errors[idx][field]) {
      const newErrors = [...errors];
      newErrors[idx][field] = undefined;
      setErrors(newErrors);
    }
  };

  // Xử lý thay đổi input liên hệ và tắt lỗi realtime
  const handleContactChange = (field, value) => {
    let newContact = { ...contact, [field]: value };
    setContact(newContact);

    // Xử lý realtime tắt lỗi khi nhập đúng
    let err = { ...contactError };
    if (field === "so_dien_thoai") {
      if (!value) {
        err.so_dien_thoai = "Vui lòng nhập số điện thoại";
      } else if (!/^0\d{9,10}$/.test(value)) {
        err.so_dien_thoai = "Số điện thoại không hợp lệ";
      } else {
        err.so_dien_thoai = "";
      }
    }
    if (field === "email") {
      if (!value) {
        err.email = "Vui lòng nhập email";
      } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/.test(value)) {
        err.email = "Email không hợp lệ";
      } else {
        err.email = "";
      }
    }
    setContactError(err);
  };

  // Get flight date for validation reference
  const ngayBay = location.state?.flight[location.state?.flight.length - 1]?.chi_tiet_chang_bay[location.state?.flight[location.state?.flight.length - 1]?.chi_tiet_chang_bay.length - 1].ngay_di; // dd-mm-yyyy
  
  const getFlightDate = () => {
    if (!ngayBay) return new Date();
    const [day, month, year] = ngayBay.split('-');
    const flightDate = new Date(year, month - 1, day);
    flightDate.setHours(0, 0, 0, 0);
    return flightDate;
  };

  // Helper: validate passenger age based on type using switch case
  const validatePassengerAge = (dob, passengerType) => {
    if (!dob) return { isValid: false, message: "Vui lòng nhập ngày sinh" };
    
    const flightDate = getFlightDate();
    const birth = new Date(dob);
    const today = new Date();
    
    // Remove time component for accurate comparison
    flightDate.setHours(0, 0, 0, 0);
    birth.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    
    // Check if birth date is valid (not today or future)
    if (birth >= today || birth > flightDate) {
      return { isValid: false, message: "Ngày sinh không hợp lệ" };
    }
    
    switch (passengerType) {
      case "Adult":
        // Calculate the date when person would turn 12
        const adultAgeDate = new Date(birth);
        adultAgeDate.setFullYear(birth.getFullYear() + 12);
        
        if (flightDate < adultAgeDate) {
          return { isValid: false, message: "Người lớn phải từ đủ 12 tuổi trở lên" };
        }
        break;
        
      case "Child":
        // Calculate the date when person would turn 2 and 12
        const childMinAgeDate = new Date(birth);
        childMinAgeDate.setFullYear(birth.getFullYear() + 2);
        const childMaxAgeDate = new Date(birth);
        childMaxAgeDate.setFullYear(birth.getFullYear() + 12);
        
        if (flightDate < childMinAgeDate || flightDate >= childMaxAgeDate) {
          return { isValid: false, message: "Trẻ em phải từ đủ 2 tuổi đến dưới 12 tuổi" };
        }
        break;
        
      case "Infant":
        // Calculate the date when person would turn 2
        const infantMaxAgeDate = new Date(birth);
        infantMaxAgeDate.setFullYear(birth.getFullYear() + 2);
        
        // Check if at least 1 day old
        const minDate = new Date(flightDate);
        minDate.setDate(flightDate.getDate() - 1);
        
        if (birth > minDate || flightDate >= infantMaxAgeDate) {
          return { isValid: false, message: "Em bé phải nhỏ hơn 2 tuổi và lớn hơn ngày bay" };
        }
        break;
        
      default:
        return { isValid: false, message: "Loại hành khách không hợp lệ" };
    }
    
    return { isValid: true, message: "" };
  };


  // Validate all passengers (add accompanyingAdult for infants, check duplicate, validate dob)
  const validate = () => {
    const newErrors = passengers.map((p, idx) => {
      const e = {};
      const dob = p.dob;
      const type = passengerList[idx].type;
      // Name
      if (!p.name) e.name = "Vui lòng nhập họ tên";
      // Title
      if (!p.title) e.title = "Vui lòng chọn danh xưng";
      // Passport, quốc tịch, ngày cấp, quốc gia cấp: chỉ cho người lớn và trẻ em
      if (type === "Adult" || type === "Child" || type === "Infant") {
        const isVN = airlines.includes("VN");
        // Nếu có hãng VN và nhập passport thì phải nhập đủ 4 trường
        var isQuocTe =
          location.state?.flight.filter(
            (val, i) =>
              val.diem_di.ten_quoc_gia !== "Việt Nam" ||
              val.diem_den.ten_quoc_gia !== "Việt Nam"
          ).length > 0;

        if (isQuocTe && (airlines.includes("VJ") || airlines.includes("uAPI"))) {
          if (!p.passport) e.passport = "Vui lòng nhập số hộ chiếu";
        }
        if (p.passport && p.passport !== "" && isVN) {
          if (!p.quoc_tich) e.quoc_tich = "Vui lòng nhập quốc tịch";
          if (!p.ngay_het_han) e.ngay_het_han = "Vui lòng nhập ngày hết hạn";
          if (!p.quoc_gia_cap) e.quoc_gia_cap = "Vui lòng nhập quốc gia cấp";
        }
        // Nếu nhập ngày hết hạn thì phải lớn hơn ngày hiện tại và ngày bay
        if (p.ngay_het_han) {
          const today = new Date();
          const flightDate = getFlightDate();
          const ngayHetHan = new Date(p.ngay_het_han);
          today.setHours(0, 0, 0, 0);
          flightDate.setHours(0, 0, 0, 0);
          ngayHetHan.setHours(0, 0, 0, 0);
          
          if (ngayHetHan <= today || ngayHetHan <= flightDate) {
            e.ngay_het_han = "Ngày hết hạn phải lớn hơn ngày ngày bay";
          }
        }
      }
      // Không bắt buộc nhập passport nữa
      // if (!p.passport) e.passport = "Vui lòng nhập số hộ chiếu";
      // DOB
      if (!dob) {
        e.dob = "Vui lòng nhập ngày sinh";
      } else {
        // Validate age using the unified function
        const ageValidation = validatePassengerAge(dob, type);
        if (!ageValidation.isValid) {
          e.dob = ageValidation.message;
        }
      }
      // Accompanying adult for infants
      if (type === "Infant") {
        if (p.accompanyingAdult === null || p.accompanyingAdult === "") {
          e.accompanyingAdult = "Vui lòng chọn người lớn đi cùng";
        } else {
          // Check for duplicate assignment
          const duplicate = passengers.some(
            (other, otherIdx) =>
              otherIdx !== idx &&
              passengerList[otherIdx].type === "Infant" &&
              other.accompanyingAdult === p.accompanyingAdult &&
              p.accompanyingAdult !== ""
          );
          if (duplicate) {
            e.accompanyingAdult = "Người lớn này đã được chọn cho em bé khác";
          }
        }
      }
      return e;
    });
    setErrors(newErrors);

    // Validate contact info
    let contactErr = {};
    if (!contact.so_dien_thoai) {
      contactErr.so_dien_thoai = "Vui lòng nhập số điện thoại";
    } else if (!/^0\d{9,10}$/.test(contact.so_dien_thoai)) {
      contactErr.so_dien_thoai = "Số điện thoại không hợp lệ";
    }
    if (!contact.email) {
      contactErr.email = "Vui lòng nhập email";
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/.test(contact.email)) {
      contactErr.email = "Email không hợp lệ";
    }
    setContactError(contactErr);

    // Return true if no errors
    return (
      newErrors.every((e) => Object.keys(e).length === 0) &&
      Object.keys(contactErr).length === 0
    );
  };

  // Handle Pay now

  useEffect(() => {
    if (location.state?.flight) {
      var airCheck = location.state.flight.filter(
        (item) => item?.hang_bay?.api === "uAPI" || item?.hang_bay?.api === "QH"
      );

      var airCheckQH = location.state.flight.filter(
        (item) => item?.hang_bay?.api === "QH"
      );

      if (airCheck.length > 0 && isNext) {
        setIsNext(false);
        handlePayNow(false, airCheckQH.length > 0 ? true : false);
      }
    }
    if (isNext && !isEmptyObject(dsDichVu)) {
      handlePayNow();
    } else if (isNext && isEmptyObject(dsDichVu)) {
      setLoading(true);
    }
  }, [isNext, dsDichVu]);

  const handlePayNow = (ischeck = true, isQH) => {
    if (validate()) {
      if (isQH) {
        var hanhKhach = [];
        var chuyenBay = [];

        passengers.forEach((p, passengerIdx) => {
          var fullName = p.name.trim();
          var parts = fullName.split(/\s+/);
          var ho = parts[0];
          var ten = parts.slice(1).join(" ");

          hanhKhach.push({
            cha_me_id:
              p.accompanyingAdult !== "" ? Number(p.accompanyingAdult) + 1 : "",
            index: passengerIdx + 1,
            hanh_khach_id: passengerIdx + 1,
            email: contact.email,
            so_dien_thoai: contact.so_dien_thoai,
            ho: ho,
            ten: ten,
            ngay_sinh: p.dob && p.dob !== "" ? formatDate(p.dob) : "",
            the_thanh_vien:
              location.state?.flight[0]?.hang_bay?.api == "VJ"
                ? p.the_thanh_vien_vj
                : location.state?.flight[0]?.hang_bay?.api == "QH"
                ? p.the_thanh_vien_qh
                : p.the_thanh_vien_vn,
            loai_hanh_khach: p.type == "Adult" ? 1 : p.type == "Child" ? 2 : 3,
            danh_xung: Number(p.title),
            ho_chieu:
              p.passport && p.passport !== ""
                ? {
                    so_ho_chieu: p.passport,
                    ngay_het_han:
                      p.ngay_het_han && p.ngay_het_han !== ""
                        ? formatDate(p.ngay_het_han)
                        : "",
                    noi_phat_hanh: p.quoc_gia_cap,
                    quoc_tich: p.quoc_tich,
                    loai: 2,
                  }
                : null,
          });
        });

        location.state?.flight
          .filter((val) => val.hang_bay.api === "QH")
          .forEach((flight, flightIdx) => {
            chuyenBay.push({
              index: flightIdx,
              uuid: flight.uuid,
              index_hang_cho: flight.tuy_chon_gia_ve_mac_dinh.index,
            });
          });

        var result = {
          api: "QH",
          hanh_khach: hanhKhach,
          chuyen_bay: chuyenBay,
          thong_tin_booker: JSON.parse(process.env.REACT_APP_BOOKER_INFO),
          xac_nhan_cho_du_bi: "",
        };

        const calculateFare = async () => {
          try {
            const data = await tinhPhiVe(result);
            if (data.code === 200) {
              navigate(
                ischeck ? "/thong-tin-dich-vu" : "/thong-tin-thanh-toan",
                {
                  state: {
                    passengers: passengers.map((p) => ({
                      ...p,
                      hanh_ly: {},
                      cho_ngoi: {
                        0: {},
                        1: {},
                      },
                      dich_vu: {
                        0: {},
                        1: {},
                      },
                    })),
                    flight: location.state?.flight,
                    contact,
                    dsDichVu,
                  },
                }
              );
            } else if (data) {
              setLoading(false);
              setSweetAlert((preState) => ({
                ...preState,
                isShow: true,
                baseProps: {
                  title: "Thông báo",
                  confirmBtnBsStyle: "success",
                  cancelBtnBsStyle: "danger",
                  showCloseButton: true,
                  showConfirm: false,
                  type: "warning",
                  onCancel: onCancel,
                  ContentRender: <p>{data.message}</p>,
                },
              }));
            }
          } catch (error) {
            setLoading(false);
          }
        };

        calculateFare();

        return;
      }

      navigate(ischeck ? "/thong-tin-dich-vu" : "/thong-tin-thanh-toan", {
        state: {
          passengers: passengers.map((p) => ({
            ...p,
            hanh_ly: {},
            cho_ngoi: {
              0: {},
              1: {},
            },
            dich_vu: {
              0: {},
              1: {},
            },
          })),
          flight: location.state?.flight,
          contact,
          dsDichVu,
        },
      });
    }
  };

  const handleNext = () => {
    if (!validate()) return;
    setIsNext(true);
  };

  const TYPEOF_NAME_OPTIONS = {
    ADULT: [
      { label: "Ông", value: 1 },
      { label: "Bà", value: 3 },
    ],
    CHILD: [
      { label: "Trẻ em trai", value: 4 },
      { label: "Trẻ em gái", value: 5 },
    ],
    INFANT: [
      { label: "Bé trai", value: 6 },
      { label: "Bé gái", value: 7 },
    ],
  };

  // Lấy danh sách người lớn có tên, chưa được chọn cho em bé khác
  const getAvailableAdultOptions = (currentInfantIdx) => {
    // Lấy tất cả người lớn đã nhập tên
    const allAdults = passengerList
      .map((p, idx) => ({ ...p, idx }))
      .filter((p) => p.type === "Adult" && passengers[p.idx]?.name?.trim());

    // Lấy các adult đã được chọn cho em bé khác
    const assignedAdults = passengers
      .map((p, idx) =>
        passengerList[idx].type === "Infant" && idx !== currentInfantIdx
          ? p.accompanyingAdult
          : null
      )
      .filter((v) => v !== null && v !== "");

    // Chỉ lấy người lớn chưa bị chọn cho em bé khác
    return allAdults.filter(
      (adult) => !assignedAdults.includes(String(adult.idx))
    );
  };

  return (
    <section id="tour_booking_submission" className="section_padding">
      {loading && <LoadingPage />}
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            <div className="tour_details_right_sidebar_wrapper" style={{}}>
              <div className="tour_detail_right_sidebar">
                <div className="tour_details_right_boxed">
                  <div className="tour_details_right_box_heading mb-2">
                    <h3>Thông tin chuyến bay</h3>
                  </div>
                  <div>
                    {(() => {
                      const flights = Array.isArray(location.state?.flight)
                        ? location.state.flight.filter(Boolean)
                        : [location.state?.flight].filter(Boolean);
                      return flights.map((flight, idx) => {
                        // Extract info safely
                        const duration = flight?.thoi_gian_bay || "";
                        const logo = flight?.hang_bay?.logo || "";
                        // Title for direction
                        let directionTitle = "";
                        if (flights.length > 1) {
                          directionTitle = idx === 0 ? "Chiều đi" : "Chiều về";
                        }
                        return (
                          <div
                            key={idx}
                            style={{
                              marginBottom: 16,
                              width: "100%",
                              border: "1px solid #e0e0e0",
                              borderRadius: 8,
                              padding: 16,
                              background: "#f8fbff",
                              boxShadow: "0 2px 8px rgba(25,118,210,0.04)",
                            }}
                          >
                            {directionTitle && (
                              <div
                                style={{
                                  fontWeight: 600,
                                  fontSize: 15,
                                  color: "#1976d2",
                                }}
                              >
                                {directionTitle}
                              </div>
                            )}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                gap: 12,
                              }}
                            >
                              {/* Điểm đi */}
                              <div
                                style={{ width: "28%", textAlign: "center" }}
                              >
                                <p
                                  style={{
                                    margin: 0,
                                    color: "#888",
                                    fontSize: 13,
                                  }}
                                >
                                  Điểm đi
                                </p>
                                <h3
                                  style={{
                                    margin: 0,
                                    fontSize: 18,
                                    fontWeight: 600,
                                  }}
                                >
                                  {flight?.diem_di.tinh}
                                </h3>
                                <p>{flight?.diem_di.ma}</p>
                              </div>
                              {/* Logo + duration */}
                              <div
                                style={{ width: "34%", textAlign: "center" }}
                              >
                                {logo && (
                                  <img
                                    src={logo}
                                    alt="logo"
                                    style={{
                                      width: 90,
                                      objectFit: "contain",
                                      marginBottom: 4,
                                    }}
                                  />
                                )}
                                <div
                                  style={{
                                    margin: "6px 0 0 0",
                                    fontWeight: 500,
                                    fontSize: 14,
                                    color: "#333",
                                  }}
                                >
                                  {flight?.so_hieu}
                                </div>
                                <div
                                  style={{
                                    fontSize: 13,
                                    color: "#1976d2",
                                    marginTop: 2,
                                  }}
                                >
                                  {duration}
                                </div>
                              </div>
                              {/* Điểm đến */}
                              <div
                                style={{ width: "28%", textAlign: "center" }}
                              >
                                <p
                                  style={{
                                    margin: 0,
                                    color: "#888",
                                    fontSize: 13,
                                  }}
                                >
                                  Điểm đến
                                </p>
                                <h3
                                  style={{
                                    margin: 0,
                                    fontSize: 18,
                                    fontWeight: 600,
                                  }}
                                >
                                  {flight?.diem_den.tinh}
                                </h3>
                                <p>{flight?.diem_den.ma}</p>
                              </div>
                            </div>
                          </div>
                        );
                      });
                    })()}
                  </div>
                </div>
              </div>

              <div className="tour_detail_right_sidebar">
                <div className="tour_details_right_boxed">
                  <div className="tour_details_right_box_heading">
                    <h3>Thông tin giá vé</h3>
                  </div>
                  <div className="tour_booking_amount_area">
                    <ul>
                      {/* Hiển thị giá từng chiều, từng loại hành khách */}
                      {(() => {
                        const flights = Array.isArray(location.state?.flight)
                          ? location.state.flight.filter(Boolean)
                          : [location.state?.flight].filter(Boolean);
                        
                        return flights.map((flight, idx) => {
                          const fare = flight?.tuy_chon_gia_ve_mac_dinh;
                          if (!fare) return null;
                          // Tên chiều
                          let directionTitle = "";
                          if (flights.length > 1)
                            directionTitle =
                              idx === 0 ? "Chiều đi" : "Chiều về";
                          // Giá từng loại
                          const adt = fare.nguoi_lon?.gia_dai_ly || 0;
                          const adt_fare = fare.nguoi_lon?.gia_fare || 0;
                          const adt_thue =
                            fare.nguoi_lon?.thue + fare.nguoi_lon?.phi_dai_ly ||
                            0;
                          const chd = fare.tre_em?.gia_dai_ly || 0;
                          const chd_fare = fare.tre_em?.gia_fare || 0;
                          const chd_thue =
                            fare.tre_em?.thue + fare.tre_em?.phi_dai_ly || 0;
                          const inf = fare.em_be?.gia_net || 0;
                          const inf_fare = fare.em_be?.gia_fare || 0;
                          const inf_thue =
                            fare.em_be?.thue  || 0;
                          // Tổng tiền chiều này
                          const totalChieu =
                            adt * adults + chd * children + inf * infants;
                          return (
                            <React.Fragment key={idx}>
                              <li
                                style={{
                                  fontWeight: 700,
                                  fontSize: 15,
                                  marginTop: idx > 0 ? 8 : 0,
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <span>{directionTitle}</span>
                                <span>{totalChieu.toLocaleString()}₫</span>
                              </li>
                              {adults > 0 && (
                                <>
                                  <li style={{ fontWeight: 600 }}>
                                    Người lớn x {adults}
                                  </li>
                                  <li
                                    style={{
                                      fontSize: 13,
                                      color: "#666",
                                      marginLeft: 10,
                                    }}
                                  >
                                    - Giá vé x {adults}:{" "}
                                    {(adt_fare * adults).toLocaleString()}₫ |
                                    Thuế phí x {adults}:{" "}
                                    {(adt_thue * adults).toLocaleString()}₫
                                  </li>
                                </>
                              )}
                              {children > 0 && (
                                <>
                                  <li style={{ fontWeight: 600 }}>
                                    Trẻ em x {children}
                                  </li>
                                  <li
                                    style={{
                                      fontSize: 13,
                                      color: "#666",
                                      marginLeft: 10,
                                    }}
                                  >
                                    - Giá vé x {children}:{" "}
                                    {(chd_fare * children).toLocaleString()}₫ |
                                    Thuế phí x {children}:{" "}
                                    {(chd_thue * children).toLocaleString()}₫
                                  </li>
                                </>
                              )}
                              {infants > 0 && (
                                <>
                                  <li style={{ fontWeight: 600 }}>
                                    Em bé x {infants}
                                  </li>
                                  <li
                                    style={{
                                      fontSize: 13,
                                      color: "#666",
                                      marginLeft: 10,
                                    }}
                                  >
                                    - Giá vé x {infants}:{" "}
                                    {(inf_fare * infants).toLocaleString()}₫ |
                                    Thuế phí x {infants}:{" "}
                                    {(inf_thue * infants).toLocaleString()}₫
                                  </li>
                                </>
                              )}
                            </React.Fragment>
                          );
                        });
                      })()}
                    </ul>
                    <div className="tour_bokking_subtotal_area">
                      {/* Tổng tiền tất cả các chiều */}
                      {(() => {
                        const flights = Array.isArray(location.state?.flight)
                          ? location.state.flight.filter(Boolean)
                          : [location.state?.flight].filter(Boolean);
                        let total = 0;
                        flights.forEach((flight) => {
                          const fare = flight?.tuy_chon_gia_ve_mac_dinh;
                          if (!fare) return;
                          total += (fare.nguoi_lon?.gia_dai_ly || 0) * adults;
                          total += (fare.tre_em?.gia_dai_ly || 0) * children;
                          total += (fare.em_be?.gia_net || 0) * infants;
                        });
                        return (
                          <h6>
                            Tổng tiền <span>{total.toLocaleString()}₫</span>
                          </h6>
                        );
                      })()}
                    </div>
                    {/* Có thể bổ sung code cho coupon hoặc discount nếu cần */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-8">
            <div className="tou_booking_form_Wrapper">
              <div className="booking_tour_form">
                <div className="tour_booking_form_box">
                  <h3 className="heading_theme">Thông tin hành khách</h3>

                  <form
                    // onSubmit={handlePayNow}
                    id="tour_bookking_form_item"
                    autoComplete="off"
                    style={{ paddingTop: 0 }}
                  >
                    {passengerList.map((p, idx) => {
                      // Determine options for title select
                      let titleOptions = [];
                      if (p.type === "Adult")
                        titleOptions = TYPEOF_NAME_OPTIONS.ADULT;
                      else if (p.type === "Child")
                        titleOptions = TYPEOF_NAME_OPTIONS.CHILD;
                      else if (p.type === "Infant")
                        titleOptions = TYPEOF_NAME_OPTIONS.INFANT;

                      // For infants, get available adult options (with name, not already assigned)
                      let adultOptions = [];
                      if (p.type === "Infant") {
                        adultOptions = getAvailableAdultOptions(idx).map(
                          (adult) => ({
                            value: adult.idx,
                            label: passengers[adult.idx]?.name,
                          })
                        );
                      }

                      return (
                        <div
                          className="mb-3"
                          key={idx}
                          style={{ borderBottom: "1px solid #eee" }}
                        >
                          <h5 className="mb-3">
                            {p.type === "Adult"
                              ? "Người lớn"
                              : p.type === "Child"
                              ? "Trẻ em"
                              : "Em bé"}{" "}
                            {(() => {
                              // Calculate correct index for each passenger type
                              if (p.type === "Adult") {
                                return passengerList
                                  .slice(0, idx + 1)
                                  .filter(
                                    (passenger) => passenger.type === "Adult"
                                  ).length;
                              } else if (p.type === "Child") {
                                return passengerList
                                  .slice(0, idx + 1)
                                  .filter(
                                    (passenger) => passenger.type === "Child"
                                  ).length;
                              } else {
                                // Infant
                                return passengerList
                                  .slice(0, idx + 1)
                                  .filter(
                                    (passenger) => passenger.type === "Infant"
                                  ).length;
                              }
                            })()}
                          </h5>
                          <div className="row">
                            <div className="col-lg-4">
                              <div className="form-group">
                                <label>
                                  Danh xưng <span className="required"> *</span>
                                </label>
                                <Select
                                  classNamePrefix="form-select"
                                  options={titleOptions}
                                  value={
                                    titleOptions.find(
                                      (opt) =>
                                        String(opt.value) ===
                                        String(passengers[idx].title)
                                    ) || null
                                  }
                                  onChange={(opt) =>
                                    handleChange(
                                      idx,
                                      "title",
                                      opt ? opt.value : ""
                                    )
                                  }
                                  placeholder="Chọn danh xưng"
                                  isClearable
                                />
                                {errors[idx].title && (
                                  <span style={{ color: "red", fontSize: 12 }}>
                                    {errors[idx].title}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="form-group">
                                <label>
                                  Họ tên <span className="required"> *</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control bg_input"
                                  placeholder="Nhập họ tên"
                                  value={passengers[idx].name}
                                  onChange={(e) => {
                                    let val = e.target.value;
                                    val = val
                                      .normalize("NFD")
                                      .replace(/[\u0300-\u036f]/g, "");
                                    val = val.replace(/[^a-zA-Z\s]/g, "");
                                    val = val.replace(/\s+/g, " ");
                                    val = val.toUpperCase();
                                    handleChange(idx, "name", val);
                                  }}
                                />
                                {errors[idx].name && (
                                  <span style={{ color: "red", fontSize: 12 }}>
                                    {errors[idx].name}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="form-group">
                                <label>
                                  Ngày sinh <span className="required"> *</span>
                                </label>
                                <CustomDateInput
                                  className="form-control bg_input"
                                  placeholder="dd/mm/yyyy"
                                  value={passengers[idx].dob}
                                  onChange={(value) =>
                                    handleChange(idx, "dob", value)
                                  }
                                />
                                {errors[idx].dob && (
                                  <span style={{ color: "red", fontSize: 12 }}>
                                    {errors[idx].dob}
                                  </span>
                                )}
                              </div>
                            </div>
                            {/* Hiển thị trường thành viên theo hãng bay, chỉ cho người lớn và trẻ em */}
                            {(p.type === "Adult" || p.type === "Child") &&
                              airlines.includes("VN") && (
                                <div className="col-lg-4">
                                  <div className="form-group">
                                    <label>Bông sen vàng</label>
                                    <input
                                      type="text"
                                      className="form-control bg_input"
                                      placeholder="Nhập bông sen vàng"
                                      value={
                                        passengers[idx].the_thanh_vien_vn || ""
                                      }
                                      onChange={(e) =>
                                        handleChange(
                                          idx,
                                          "the_thanh_vien_vn",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              )}
                            {(p.type === "Adult" || p.type === "Child") &&
                              airlines.includes("QH") && (
                                <div className="col-lg-4">
                                  <div className="form-group">
                                    <label>Thẻ thành viên (QH)</label>
                                    <input
                                      type="text"
                                      className="form-control bg_input"
                                      placeholder="Nhập thẻ thành viên (QH)"
                                      value={
                                        passengers[idx].the_thanh_vien_qh || ""
                                      }
                                      onChange={(e) =>
                                        handleChange(
                                          idx,
                                          "the_thanh_vien_qh",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              )}
                            {(p.type === "Adult" || p.type === "Child") &&
                              airlines.includes("VJ") && (
                                <div className="col-lg-4">
                                  <div className="form-group">
                                    <label>Thẻ thành viên (VJ)</label>
                                    <input
                                      type="text"
                                      className="form-control bg_input"
                                      placeholder="Nhập thẻ thành viên (VJ)"
                                      value={
                                        passengers[idx].the_thanh_vien_vj || ""
                                      }
                                      onChange={(e) =>
                                        handleChange(
                                          idx,
                                          "the_thanh_vien_vj",
                                          e.target.value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              )}
                            {/* Hiển thị trường passport, quốc tịch, ngày cấp, quốc gia cấp chỉ cho người lớn và trẻ em */}
                            {(p.type === "Adult" || p.type === "Child" || airlines.includes("uAPI")) && (
                              <>
                                <div className="col-lg-4">
                                  <div className="form-group">
                                    <label>Quốc tịch</label>
                                    <Select
                                      classNamePrefix="form-select"
                                      options={countryOptions}
                                      value={
                                        countryOptions.find(
                                          (opt) =>
                                            opt.value ===
                                            passengers[idx].quoc_tich
                                        ) || null
                                      }
                                      onChange={(opt) =>
                                        handleChange(
                                          idx,
                                          "quoc_tich",
                                          opt ? opt.value : ""
                                        )
                                      }
                                      placeholder="Chọn quốc tịch"
                                      isClearable
                                    />
                                    {errors[idx].quoc_tich && (
                                      <span
                                        style={{ color: "red", fontSize: 12 }}
                                      >
                                        {errors[idx].quoc_tich}
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-4">
                                  <div className="form-group">
                                    <label>Số hộ chiếu</label>
                                    <input
                                      type="text"
                                      className="form-control bg_input"
                                      placeholder="Nhập số hộ chiếu"
                                      value={passengers[idx].passport || ""}
                                      onChange={(e) =>
                                        handleChange(
                                          idx,
                                          "passport",
                                          e.target.value
                                        )
                                      }
                                    />
                                    {errors[idx].passport && (
                                      <span
                                        style={{ color: "red", fontSize: 12 }}
                                      >
                                        {errors[idx].passport}
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-4">
                                  <div className="form-group">
                                    <label>Ngày hết hạn</label>
                                    <CustomDateInput
                                      className="form-control bg_input"
                                      placeholder="dd/mm/yyyy"
                                      value={passengers[idx].ngay_het_han || ""}
                                      onChange={(value) =>
                                        handleChange(idx, "ngay_het_han", value)
                                      }
                                    />
                                    {errors[idx].ngay_het_han && (
                                      <span
                                        style={{ color: "red", fontSize: 12 }}
                                      >
                                        {errors[idx].ngay_het_han}
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div className="col-lg-4">
                                  <div className="form-group">
                                    <label>Quốc gia cấp</label>
                                    <Select
                                      // className="form-select bg_input"
                                      classNamePrefix="form-select"
                                      options={countryOptions}
                                      value={
                                        countryOptions.find(
                                          (opt) =>
                                            opt.value ===
                                            passengers[idx].quoc_gia_cap
                                        ) || null
                                      }
                                      onChange={(opt) =>
                                        handleChange(
                                          idx,
                                          "quoc_gia_cap",
                                          opt ? opt.value : ""
                                        )
                                      }
                                      placeholder="Chọn quốc gia cấp"
                                      isClearable
                                    />
                                    {errors[idx].quoc_gia_cap && (
                                      <span
                                        style={{ color: "red", fontSize: 12 }}
                                      >
                                        {errors[idx].quoc_gia_cap}
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </>
                            )}
                            {/* For infants, add accompanying adult select */}
                            {p.type === "Infant" && (
                              <div className="col-lg-4">
                                <div className="form-group">
                                  <label>Người lớn đi cùng</label>
                                  <Select
                                    classNamePrefix="form-select"
                                    options={adultOptions}
                                    value={
                                      adultOptions.find(
                                        (opt) =>
                                          String(opt.value) ===
                                          String(
                                            passengers[idx].accompanyingAdult
                                          )
                                      ) || null
                                    }
                                    onChange={(opt) =>
                                      handleChange(
                                        idx,
                                        "accompanyingAdult",
                                        opt ? opt.value : ""
                                      )
                                    }
                                    placeholder="Chọn người lớn đi cùng"
                                    isClearable
                                  />
                                  {errors[idx].accompanyingAdult && (
                                    <span
                                      style={{ color: "red", fontSize: 12 }}
                                    >
                                      {errors[idx].accompanyingAdult}
                                    </span>
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </form>
                </div>
              </div>
            </div>

            {/* Card thông tin liên hệ riêng */}
            <div className="tou_booking_form_Wrapper mt-4">
              <div className="booking_tour_form">
                <div className="tour_booking_form_box">
                  {/* Thông tin liên hệ */}
                  <div>
                    <h4 className="heading_theme mb-3">Thông tin liên hệ</h4>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>
                            Số điện thoại <span className="required"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control bg_input"
                            placeholder="Nhập số điện thoại"
                            value={contact.so_dien_thoai}
                            onChange={(e) =>
                              handleContactChange(
                                "so_dien_thoai",
                                e.target.value.replace(/[^0-9]/g, "")
                              )
                            }
                          />
                          {contactError.so_dien_thoai &&
                            contactError.so_dien_thoai !== "" && (
                              <span style={{ color: "red", fontSize: 12 }}>
                                {contactError.so_dien_thoai}
                              </span>
                            )}
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <label>
                            Email<span className="required"> *</span>
                          </label>
                          <input
                            type="email"
                            className="form-control bg_input"
                            placeholder="Nhập email"
                            value={contact.email}
                            onChange={(e) =>
                              handleContactChange("email", e.target.value)
                            }
                          />
                          {contactError.email && contactError.email !== "" && (
                            <span style={{ color: "red", fontSize: 12 }}>
                              {contactError.email}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Nút tiếp tục dưới card */}
            <div className="d-flex mt-3 justify-content-end">
              <button
                className="btn btn-secondary"
                style={{ minWidth: 150 }}
                onClick={() => {
                  navigate("/");
                }}
              >
                Quay lại
              </button>
              <button
                className="btn btn-primary ms-2"
                style={{
                  minWidth: 150,
                  fontWeight: 600,
                  padding: "12px 24px",
                  borderRadius: 8,
                  boxShadow: "0 2px 8px rgba(25,118,210,0.15)",
                }}
                onClick={handleNext}
              >
                Tiếp tục
              </button>
            </div>
          </div>
        </div>
      </div>
      {sweetAlert.isShow === true && (
        <SweetAlert {...sweetAlert.baseProps}>
          {sweetAlert.baseProps.ContentRender}
        </SweetAlert>
      )}
    </section>
  );
}
